import React from 'react';
import styleText from '../../../shared/components/rbh-text/styles';
import { Colors } from '../../../shared/theme/';
import fonts from '../../../shared/theme/fonts';
import metrics from '../../../shared/theme/metrics';

export default {
  defaultContent: {
    backgroundColor: Colors.white,
    padding: 20,
  } as React.CSSProperties,
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    paddingBottom: metrics.base * 2,
    height: '56px'
  } as React.CSSProperties,
  selectedMenuItem: {
    backgroundColor: Colors.selectedFilter
  },
  imageBox: {
    verticalAlign: 'top',
    display: 'inline-block',
    height: '64px',
    width: '64px'
  },
  image: {
    borderRadius: '4px',
    height: '100%',
    width: '100%'
  },
  menuNameBox: {
    marginLeft: '12px',
    display: 'inline-block',
    width: 'calc(100% - 76px)',
  },
  emptyProductHeader: {
    ...styleText.text16fakeBlack,
    marginBottom: metrics.base
  },
  emptyProductDesc: {
    ...styleText.textRegular14Gray,
    marginBottom: metrics.base * 4
  },
  emptyWrapper: {
    textAlign: 'center',
    marginTop: metrics.base * 10
  },
  subTitleText: {
    ...styleText.textRegular14,
    color: Colors.font.primary.darkGray,
    marginBottom: metrics.base * 2
  },
  bannerBox: {
    paddingBottom: metrics.baseMargin + 4,
  },
  banner: {
    border: '1px solid #FFA39E',
    backgroundColor: Colors.tagPalered
  },
  messageQc: {
    ...fonts.style.textHeaderKanitRegular14,
    color: Colors.font.messaging.errorRed,
  },
  qcRejectReasons: {
    ...fonts.style.textHeaderKanitRegular14,
    color: Colors.font.messaging.errorRed,
    whiteSpace: 'pre-wrap'
  },
  qcRejectReasonsBox: {
    paddingBottom: metrics.baseMargin / 2,
    paddingTop: metrics.baseMargin / 2,
  },
  BackTop: {
    height: 40,
    width: 40,
    lineHeight: '40px',
    marginRight: '8%'
  },
  circleBox: {
    width: 40,
    height: 40,
    borderRadius: '50%',
    backgroundColor: Colors.white,
    borderColor: Colors.lightPurple,
  },
  iconBackToTop: {
    fontSize: 24,
    color: Colors.lightPurple,
    cursor: 'pointer'
  },
  textLimitItem: {
    ...fonts.style.textDescriptionKanitLight12,
    color: Colors.font.primary.gray,
  },
  promotionPeriodBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  promotionPeriodIcon: {
    color: Colors.font.primary.gray,
  },
  promotionPeriodText: {
    ...fonts.style.textBodyRegularGray12,
    marginLeft: '4px',
  },
  promotionPriceBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  promotionPriceText: {
    ...styleText.textRed,
    fontSize: fonts.size.text12,
  },
  promotionPriceInfoIcon: {
    color: Colors.font.primary.gray,
  },
  tooltipPromotionPriceBox: {
    display: 'flex',
    marginLeft: '2px',
  },
  tooltipBoxPromotionPeriodInfo: {
    fontFamily: fonts.type.KanitRegular,
    fontSize: fonts.size.text12,
    color: Colors.white,
    whiteSpace: 'pre-wrap',
  },
};
